import React, {Fragment, useEffect, createRef} from 'react';
import {useInView} from "react-intersection-observer";
import anime from 'animejs';
import styled from 'styled-components';

const Data = styled.h1`
  font-weight: 700;
  margin: 0;
  padding-bottom: 0;
  font-size: 2.25rem;
  line-height: 1.2;
  transition: all .5s ease;
  color: ${({color}) => color ? color : '#0A2540'};
`;
const WordWrap = styled.span`
  display: inline-block;
  overflow: hidden;
`;
const Word = styled.span`
  display: inline-block;
  opacity: 0;
  transform: translateY(60px);
`;

const Title = ({className, color, children, level = 1}) => {
  let wordRefs = [];
  let textSpans = '';
  if (children) {
    textSpans = (children.indexOf(' ') !== -1) ? children.split(' ') : [children];
  }

  for (let i = 0; i < textSpans.length; i++) {
    wordRefs[i] = createRef();
    if (i === 0) {
      textSpans[i] = <WordWrap key={i}><Word ref={wordRefs[i]}>{textSpans[i]}</Word></WordWrap>;
    } else {
      textSpans[i] = <Fragment key={i}> <WordWrap><Word ref={wordRefs[i]}>{textSpans[i]}</Word></WordWrap></Fragment>;
    }
  }

  const [ref, inView] = useInView({
    triggerOnce: true
  });

  useEffect(() => {
    const targets = Array.from(wordRefs, el => el.current);

    if (inView) {
      anime({
        targets: targets,
        translateY: [60, 0],
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1000,
        delay: (el, i) => 250 + 30 * i
      });
    }

    return () => anime({
      targets: targets,
      translateY: 60,
      opacity: 0,
      easing: "easeOutExpo",
      duration: 100,
    });
  }, [inView, textSpans]);

  return <Data className={className} color={color} ref={ref} as={'h' + level}>{textSpans}</Data>;
};

export default Title;